import React, { Component, useCallback, useEffect, useState } from 'react'
import './OnboardCard.sass'

import {
  BsEmojiSunglasses,
  BsSun,
  BsPeople,
  BsPersonBoundingBox,
  BsEmojiWink
} from 'react-icons/bs'

interface Props {
  onResponse: (response: any) => void
}

declare global {
  interface Window {
    constraints: any
    stream: any
  }
}

const constraints = (window.constraints = {
  video: true
})

function FaceInstructions({ onResponse }: Props) {
  const [photoState, setphotoState] = useState<string>('')

  const [userHasCamera, setUserHasCamera] = useState(true)

  const handleResponse = useCallback((message: string) => {
    setphotoState(message)
  }, [])

  useEffect(() => {
    const params = new URLSearchParams(window.location.search) // id=123
    if (params.get('fixBrowser')) {
      setphotoState('mobile')
    }
  }, [])

  const handleSuccess = (stream: any) => {
    setUserHasCamera(true)
    const videoTracks = stream.getVideoTracks()
  }

  return (
    <>
      <div className={`${photoState} card`}>
        {userHasCamera ? (
          <div className="have-camera">
            <h1>
            Some <span>tips:</span>
            </h1>
            <ul className="instruction-list list-group">
              <li className="list-group-item">
                <i>
                  <BsSun />
                </i>
                Find a well-lit location with a neutral background, such as a white wall.
              </li>
              <li className="list-group-item">
                <i>
                  <BsPersonBoundingBox />
                </i>
                Fit your face image into the frame.
              </li>
              <li className="list-group-item">
                <i>
                  <BsPeople />
                </i>
                {`Make sure there's no other person in the capture field.`}</li>
              <li className="list-group-item">
                <i>
                  <BsEmojiWink />
                </i>
                Do not smile or blink your eyes.
              </li>
              <li className="list-group-item">
                <i>
                  <BsEmojiSunglasses />
                </i>
                Do not wear glasses, masks, or hats.
              </li>
            </ul>
            <div className="form-group form-submit">
              <a
                className="btn btn-primary form-control form-control-lg"
                onClick={() => onResponse({ step: 'faceproceed' })}
              >
                {`Let's do it?!`}
              </a>
            </div>
          </div>
        ) : (
          <div className="no-camera">
            {' '}
            <h1>
              Não achamos <span>sua câmera</span>
            </h1>
            <p>
              Não conseguimos acessar sua câmera para prosseguir. <br />
              Por favor, revise as permissões do seu aplicativo ou tente com
              outro celular
            </p>
            <div className="form-group form-submit">
              <a
                className="btn btn-primary form-control form-control-lg"
                onClick={() => window.location.reload()}
              >
                Recarregar
              </a>
            </div>
          </div>
        )}
      </div>
      <ul className="step-counter">
        <li className="active"></li>
        <li className="active"></li>
        <li className="active"></li>
        <li></li>
      </ul>
    </>
  )
}

export default FaceInstructions
